module.exports = __webpack_public_path__ + "static/placead-a05b8d21f2611bac732bfd9b0945651f.jpg";